<template>
  <div class="d-flex justify-center">
    <div class="main-card mt-3">
      <!-- <div class="mb-5">
        <v-btn @click="toggleLogin" color="primary"> Toggle login </v-btn>
        User Logged In: {{ $store.getters.userLoggedIn }}
        <v-btn @click="togglePro" color="secondary"> Toggle pro </v-btn>
        Pro User: {{ $store.getters.isProUser }}
      </div> -->
      <v-stepper v-model="step" flat>
        <v-stepper-header style="box-shadow: none">
          <v-stepper-step :complete="step > 1" step="1">
            Select option
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2" lazy-validation>
            Upload resume
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3"> Submit </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="pr-0 mr-0 pl-0 ml-0">
            <v-card elevation="0">
              <v-row>
                <v-col cols="12" class="text-center pb-0">
                  <h2 class="text-h5 font-weight-bold">
                    Choose your AI resume review
                  </h2>
                  <p class="text-subtitle-1 grey--text text--darken-1 mb-0">
                    Pick the level of feedback that fits where you are in your
                    job search.
                  </p>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col
                  cols="12"
                  md="6"
                  lg="4"
                  v-for="o in aiOptions"
                  v-bind:key="o.id"
                  class="d-flex flex-column"
                >
                  <ai-pricing-card
                    :optionName="o.name"
                    :optionId="o.id"
                    :optionPrice="o.price"
                    :optionColor="o.color"
                    :optionFeatures="o.features"
                    :optionIcon="o.icon"
                    :tag="o.tag"
                    :exampleUrl="o.exampleUrl"
                    @pricingOptionSelected="pricingSelected"
                    :proOption="o.proOption"
                  />
                </v-col>
              </v-row>
              <v-card-actions class="mt-5"> </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card elevation="0">
              <v-form ref="refForm">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" v-if="selOptionId != ''">
                      <v-chip
                        :color="getOptionById(selOptionId)?.color"
                        text-color="white"
                      >
                        {{
                          getOptionById(selOptionId)?.name ||
                          "No option selected"
                        }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12">
                      <p class="text-h6">Upload your resume</p>
                      <p class="text-subtitle-1">Select a PDF file.</p>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input
                        v-model="resumeFile"
                        label="Resume file"
                        accept=".pdf"
                        @change="uploadFile"
                        outlined
                        required
                        :disabled="loading"
                        :rules="fileRules"
                      ></v-file-input>
                      <v-progress-linear
                        indeterminate
                        v-if="loading"
                      ></v-progress-linear>
                      <p
                        v-if="fileUploadError != ''"
                        class="mb-0 mt-1 ml-9"
                        style="color: #b71c1c; line-height: 12px"
                      >
                        {{ fileUploadError }}
                      </p>
                      <p
                        v-if="selFileHash != ''"
                        class="mb-0 mt-1 ml-9"
                        style="color: green; line-height: 12px"
                      >
                        File uploaded successfully
                      </p>
                    </v-col>
                    <v-col cols="12" v-if="selOptionId == 'TargetedAI'">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" v-if="selOptionId == 'TargetedAI'">
                      <p class="text-subtitle-1">
                        Job opening you want to target with this resume:
                      </p>
                      <v-text-field
                        label="Job opening url"
                        class="mt-2"
                        v-model="jobPostingUrl"
                        required
                        :rules="urlRules"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="mt-3">
                  <v-btn @click="step = 1" :disabled="loading"> Back </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    style="min-width: 150px"
                    @click="step2Continue()"
                    :disabled="loading"
                  >
                    Continue
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card elevation="0">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <p class="text-h6">Submit your resume</p>
                  </v-col>
                  <v-col cols="12" class="mt-0">
                    <div class="d-flex flex-row">
                      <p class="text-subtitle-1 font-weight-medium">
                        Selected option:
                        <v-chip
                          :color="getOptionById(selOptionId)?.color"
                          text-color="white"
                        >
                          {{
                            getOptionById(selOptionId)?.name ||
                            "No option selected"
                          }}
                        </v-chip>
                      </p>
                    </div>
                    <div class="d-flex flex-row">
                      <p class="text-subtitle-1 font-weight-medium">
                        Your email:
                      </p>
                      <p class="text-subtitle-1 ml-2">
                        {{ selEmail }}
                      </p>
                    </div>
                    <div class="d-flex flex-row">
                      <p class="text-subtitle-1 font-weight-medium">
                        Resume file:
                      </p>
                      <p class="text-subtitle-1 ml-2">
                        {{ selFileName }}
                      </p>
                    </div>
                    <div
                      class="d-flex flex-row"
                      v-if="selOptionId == 'TargetedAI'"
                    >
                      <p class="text-subtitle-1 font-weight-medium">
                        Job posting url:
                      </p>
                      <p class="text-subtitle-1 ml-2">
                        {{ jobPostingUrl }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="dailyLimitExceeded">
                  <v-col cols="12">
                    <v-alert type="warning" dense outlined class="mt-0">
                      You have exceeded the daily limit for resume evaluations.
                      Please try again tomorrow or upgrade to PRO.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row v-if="submitErrors.length > 0">
                  <v-col cols="12">
                    <p
                      class="mb-0 mt-1"
                      style="color: #b71c1c; line-height: 12px"
                      v-if="submitErrors.length > 0"
                    >
                      Submit errors:
                    </p>
                    <p
                      class="mb-0 mt-1"
                      style="color: #b71c1c; line-height: 12px"
                      v-for="err in submitErrors"
                      v-bind:key="err"
                    >
                      - {{ err }}
                    </p>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="mt-3">
                <v-btn @click="step = 2" :disabled="loading"> Back </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  style="min-width: 150px"
                  @click="submitEvaluation()"
                  :loading="loading"
                  :disabled="dailyLimitExceeded"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-snackbar v-model="snackbar" outlined>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false" class="gray--text">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AiPricingCard from "@/components/AiPricingCard.vue";
export default {
  components: {
    AiPricingCard,
  },
  data() {
    return {
      selOptionId: "",
      step: 1,
      snackbarText: "",
      snackbar: false,
      resumeFile: null,
      selFile: null,
      selFileName: "",
      // Hash of the uploaded file returned by the backend after upload. If this is not empty, the file has been uploaded successfully.
      selFileHash: "",
      loading: false,
      skipValidation: false,
      fileUploadError: "",
      dailyLimitExceeded: false,
      submitErrors: [],
      selEmail: "",
      aiOptions: [
        {
          name: "BASIC",
          id: "BasicAI",
          price: "FREE",
          color: "#f57c00",
          icon: "mdi-file-search-outline",
          proOption: false,
          features: [
            "Overall rating",
            "Parsability evaluation",
            "Data checks",
            "Basic format checks",
          ],
          exampleUrl: "/review-status-ai?reviewId=101-example",
        },
        {
          name: "FULL",
          id: "FullAI",
          price: "INCLUDED IN PRO",
          color: "#4caf50",
          icon: "mdi-rocket-launch-outline",
          tag: "MOST POPULAR",
          proOption: true,
          features: [
            "Overall rating",
            "Career progression analysis",
            "Technologies list and profficiency evaluation",
            "Parsability evaluation",
            "Full data checks",
            "Data quality",
            "Full format checks",
            "Job hopping potential",
            "Education evaluation",
            "Certificates evaluation",
            "Projects evaluation",
          ],
          exampleUrl: "/review-status-ai?reviewId=105-example",
        },
        {
          name: "TARGETED",
          id: "TargetedAI",
          price: "INCLUDED IN PRO",
          color: "#2196f3",
          icon: "mdi-bullseye-arrow",
          tag: "BEST MATCH",
          proOption: true,
          features: [
            "Job match rating",
            "Job match summary",
            "Minimum qualifications evaluation",
            "Preferred qualifications evaluation",
          ],
          exampleUrl: "/review-status-ai?reviewId=110-example",
        },
      ],
      jobPostingUrl: "",
      isProUser: false,
      fileRules: [
        (value) => {
          if (value == null) return "File is required";
          if (value.size > 10000000)
            //10 MB
            return "Resume size should be less than 10 MB";
          return true;
        },
      ],
      urlRules: [
        (v) => !!v || "URL is required", // must not be empty.
        (v) => {
          try {
            const u = new URL(v); // throws if not a valid URL, (handles ports, IPv6, query strings, #hash, etc.).
            return (
              u.protocol === "http:" ||
              u.protocol === "https:" ||
              "URL must start with http:// or https://" // only accepts those two schemes.
            );
          } catch {
            return "Invalid URL";
          }
        },
      ],
    };
  },
  mounted() {
    this.$utils.visit(this);
    this.getUserProStatus();
    if (this.$route.query.option == "full") {
      this.selOptionId = "FullAI";
      this.step = 2;
    } else if (this.$route.query.option == "targeted") {
      this.selOptionId = "TargetedAI";
      this.step = 2;
    }
    this.selEmail = this.$store.getters.getUser;
  },
  methods: {
    pricingSelected(selName) {
      console.log("pricingSelected: " + selName);
      var option = this.aiOptions.find(({ id }) => id === selName);
      if (option) {
        this.selOptionId = option.id;
        this.step = 2;
      } else {
        console.log("Error selecting pricing option");
      }
    },
    step2Continue() {
      if (this.skipValidation) {
        this.step = 3;
        return;
      }
      this.$refs.refForm.validate();
      var selFileValid = this.selFileHash != "";
      if (!selFileValid) {
        this.snackbarText = "Please upload a valid resume file to continue.";
        return;
      }
      if (this.selOptionId == "TargetedAI") {
        var jobPostingValid = this.urlRules.every(
          (rule) => rule(this.jobPostingUrl) === true,
        );
        if (!jobPostingValid) {
          this.snackbarText =
            "Please enter a valid job posting url to continue.";
          return;
        }
      }
      this.step = 3;
    },
    async uploadFile(file) {
      if (file == null) return;
      this.loading = true;
      this.fileUploadError = "";
      this.selFileHash = "";
      this.selFileName = "";
      let formData = new FormData();
      formData.append("file", file);
      this.selFile = file;
      this.selFileName = file.name;
      try {
        await this.$http
          .post(this.$consts.BE_ADDRESS + "/pub/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log("response.status: " + response.status);
            console.log("response.data.fileHash: " + response.data.fileHash);
            if (response.status === 200) {
              this.selFileHash = response.data.fileHash;
            } else {
              this.fileUploadError = "Upload error: " + response.status;
            }
          })
          .catch((error) => {
            this.fileUploadError = "Upload error: " + error;
          });
      } catch (err) {
        this.fileUploadError = "Upload error: " + err;
      } finally {
        this.loading = false;
      }
    },
    async submitEvaluation() {
      this.submitErrors = this.presubmitValidation();
      if (this.submitErrors.length > 0) {
        return;
      }
      console.log("submitEvaluation()");
      this.loading = true;
      this.submitErrors = [];
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/submitResumeAI",
          {
            resumeHash: this.selFileHash,
            resumeFileName: this.selFileName,
            pricing: this.selOptionId,
            jobPostingUrl: this.jobPostingUrl,
          },
        );
        this.$utils.trackEvent("submit_resume_evaluation", {
          tier: this.getOptionById(this.selOptionId)?.name || this.selOptionId,
        });
        // redirect to review status page
        this.$router.push({
          name: "review-status-ai",
          query: { reviewId: resp.reviewId, txtLoading: "true" },
        });
      } catch (error) {
        // check if error contains "Daily AI evaluation limit reached." and set dailyLimitExceeded to true if so, otherwise add error to submitErrors
        if (error.toString().includes("Daily AI evaluation limit reached")) {
          this.dailyLimitExceeded = true;
        } else {
          this.submitErrors.push(error);
        }
      } finally {
        this.loading = false;
      }
    },
    presubmitValidation() {
      let errors = [];
      if (this.selFileHash == "") {
        errors.push("resume file is missing");
      }
      if (this.selEmail == "") {
        errors.push("email is missing");
      }
      if (
        this.selOptionId == "" ||
        this.getOptionById(this.selOptionId) == null
      ) {
        errors.push("evaluation option is missing or invalid");
      }
      return errors;
    },
    selectOptionById(id) {
      var option = this.aiOptions.find((o) => o.id === id);
      if (option) {
        this.selOptionId = option.id;
      }
    },
    // Reactivity issue workaround - get option by id
    getOptionById(id) {
      return this.aiOptions.find((o) => o.id === id);
    },
    async getUserProStatus() {
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/getProStatus",
          {},
        );
        console.log("getUserProStatus resp: " + JSON.stringify(resp));
        this.userIsPro = resp.isPro;
        this.activeSubscription = resp.activeSubscription;
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.loading = false;
      }
    },

    // toggleLogin() {
    //   if (this.$store.getters.userLoggedIn) {
    //     this.$store.dispatch("logout");
    //   } else {
    //     this.$store.commit("setUser", "burmix@gmail.com");
    //   }
    //   this.selEmail = this.$store.getters.getUser;
    // },
    // togglePro() {
    //   if (this.$store.getters.isProUser) {
    //     this.$store.commit("setIsPro", false);
    //   } else {
    //     this.$store.commit("setIsPro", true);
    //   }
    //   this.isProUser = this.$store.getters.isProUser;
    // },
  },
};
</script>

<style scoped>
.main-card {
  width: 100vw;
  max-width: 1200px;
}
</style>
